define('handlebarsHelpers',[
	"constants",
	"underscore",
	"oaConfig",
	"utils",
	"handlebars",
	"underscore-string",
	"localizationService",
	"tsgUtils"
],

function(Constants, _, Config, Utils, Handlebars, _S, LocalizationService, TSGUtils) {

	// Takes in the name of a variable as the first param and the string that you are concatenating
	// as the second.
	Handlebars.registerHelper('concat', function(varName, str, options) {
		options.data.root[varName] += str + "\n";
	});

	// Adds color to the thumbnail icons when multiple users are viewing the same document
	Handlebars.registerHelper('getRandomColor', function(colorNumber) {
		switch(colorNumber) {
			case 1: {
				return new Handlebars.SafeString('light-green');
			}
			case 2: {
				return new Handlebars.SafeString('dark-green');
			}
			case 3: {
				return new Handlebars.SafeString('light-blue');
			}
			case 4: {
				return new Handlebars.SafeString('dark-blue');
			}
			case 5: {
				return new Handlebars.SafeString('yellow');
			}
			case 6: {
				return new Handlebars.SafeString('orange');
			}
			case 7: {
				return new Handlebars.SafeString('red');
			}
			default: {
				return new Handlebars.SafeString('blue')
			}
		}
	});

	// Register a Handlebars helper
	Handlebars.registerHelper('strip-scripts', function (context) {
		var html = context;
		return new Handlebars.SafeString(html);
	});

	// Translates our status content from english to the configured locale
	Handlebars.registerHelper('displayStatusContent', function (status, type) {
		if (status && status !== "None") {
			var replaceType;
			// Localize the type if it is on the content
			if (type && _S.startsWith(status, type + " ")) {
				replaceType = true;
				status = status.replace(type + " ", "");
				if (Config.xfdfFieldLocalizationMap[type]) {
					type = LocalizationService.localize(Config.xfdfFieldLocalizationMap[type]);
				}
				type += " ";
			}

			// Localize 'set by' if it is on the content
			if (_S.startsWith(status,"set by ")) {
				status = status.replace("set by", LocalizationService.localize("viewer.dialogAnnotation.comment.setBy"));
			}

			if (replaceType) {
				status = type + status;
			}
		}
		return status;
	});

	// Translates our status content from english to the configured locale
	Handlebars.registerHelper('displayStatusesInPrintSummary', function (statusMap) {
		var overallStatusMessage = "";

		// When we have no statues, the statusMap is actually just a string that says none, we can just return this
		// as we want to display none for these annotations
		if(statusMap === "None") {
			return statusMap;
		} else {
			_.each(statusMap, function(statusModel){
				var status = statusModel.xfdfFields.content;
				var type = statusModel.xfdfFields.state;
				// if our status exists but it is none, we don't want to display that
				// The rest of the block below is helping to localize the status message that will
				// get displayed in the print summary
				if (status && type !== "None") {
					var replaceType;
					// Localize the type if it is on the content
					if (type && _S.startsWith(status, type + " ")) {
						replaceType = true;
						status = status.replace(type + " ", "");
						if (Config.xfdfFieldLocalizationMap[type]) {
							type = LocalizationService.localize(Config.xfdfFieldLocalizationMap[type]);
						}
						type += " ";
					}
		
					// Localize 'set by' if it is on the content
					if (_S.startsWith(status,"set by ")) {
						status = status.replace("set by", LocalizationService.localize("viewer.dialogAnnotation.comment.setBy"));
					}
		
					// Here we grab the localized status message, and append to the overall status message
					// that will be a comma delimited string of all the statuses
					if (replaceType) {
						overallStatusMessage += type + status + ",";
					}
				}
			});

			// This bit is helping to cut off the last comma in the string, so we aren't left hanging with a comma at the
			// end of the string
			if(overallStatusMessage.length > 0) {
				overallStatusMessage = overallStatusMessage.slice(0, -1);
			}
			return overallStatusMessage;
		}
	});

	// a helper to display different text for the different annotation types we have
	Handlebars.registerHelper('displayType', function (annotationType, annotationTail) 
	{
		// TODO: Localize these string values
		// Lines an arrows are both of type "Line", so when the tail value is "OpenArrow" we have an arrow
		if (annotationType === "Line" && annotationTail === "OpenArrow") {
			return "Arrow";
		} else if (annotationType === "Oval") {
			return "Ellipse";
		} else if (annotationType === "OpenArrow") {
			return "Arrow";
		} else if (annotationType === "Cross-Out") {
			return "Strikeout";
		} else {
			return annotationType;
		}
	});

	// Allows for 'dynamic' localization in HTML based on a map
	Handlebars.registerHelper('mapLocalize', function (localizationString) {
		if (Config.xfdfFieldLocalizationMap[localizationString]) {
			return LocalizationService.localize(Config.xfdfFieldLocalizationMap[localizationString]);
		} else {
			return localizationString;
		}
	});

	// register our page zoomed width handlebars helper
	Handlebars.registerHelper('zoomedWidth', function(model) {
		return model.width * model.zoom;
	});

	// register our page zoomed height handlebars helper
	Handlebars.registerHelper('zoomedHeight', function(model) {
		return model.height * model.zoom;
	});

	// register our localization handlebars helper
	Handlebars.registerHelper('localize', function(value) {
		return value ? new Handlebars.SafeString(LocalizationService.sLocalize(value)) : new Handlebars.SafeString('');
	});

	// A helper to get the correct icon image for the attached doc.
	Handlebars.registerHelper('getIconPath', function(mimeType) {
	 	var imagePath = Constants.MIMETYPE_ICON_MAP[mimeType];
	 	imagePath = imagePath ? imagePath : "images/icons/unknown.gif";

	 	return imagePath;
	});

	// A helper to format our dates in the table in the format the user has configured
	Handlebars.registerHelper('formatDate', function (dateToFormat) {
		return Utils.dateFormatter(dateToFormat, Config.dateFormat);
	});

	// A helper to get a reply's most recent status if it exists, or otherwise return "None".
	Handlebars.registerHelper('getReplyStatus', function (replyAnnotation) {
		 var statusMap = _.reduce(replyAnnotation.statuses, function(map, statusAttributes){
			map[statusAttributes.xfdfFields.title] = statusAttributes;
			return map;
		}, {} );

		var statusString = "";
		_.each(statusMap, function(liveStatuses) {
			if(liveStatuses.xfdfFields.state !== "None") {
				statusString += "\n" + liveStatuses.xfdfFields.state;
			}
		}, this);
		return !_.isEmpty(replyAnnotation.statuses) ? statusString : "None";
	});

	// A helper to manipulate a string into lower case.
	Handlebars.registerHelper('toLowerCase', function (str) {
		return (str && typeof str === 'string') ? new Handlebars.SafeString(str.toLowerCase()) : new Handlebars.SafeString('');
	});

	// A helper to color code the display times.
	Handlebars.registerHelper('timeColor', function(time) {
		return Utils.timeColor(time, 1.0, 3.0);
	});

	// a helper to determine if times brought in should be appended with 'secs'
	Handlebars.registerHelper('displayLoadTime', function(time) {
		if (isNaN(time)) {
			// this means our request was cached or the filter is disabled so we do not want to add 'secs'
			return new Handlebars.SafeString(time);
		} else {
			return new Handlebars.SafeString(LocalizationService.sLocalize("viewer.toolbar.timer.secs", {
				"time": time
			}));
		}
	});

	// A helper to color code the display doc sizes
	Handlebars.registerHelper('docSizeColor', function(docSize) {
		if(docSize <= TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_MEGABYTE) {
			return 'positive';
		} else if(docSize <= 50*TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_MEGABYTE) {
			return 'neutral';
		} else {
			return 'negative';
		}
	});

	// a helper to determine if the doc size brought in should be converted to KB, MB, or GB
	Handlebars.registerHelper('displayDocSize', function(docSize) {
		if (isNaN(docSize)) {
			// this means our request was cached or the filter is disabled so we do not want to modify the value
			return new Handlebars.SafeString(docSize);
		} else if (docSize >= TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_GIGABYTE){
			// a doc size that is at least 1 GB should be displayed as a GB
			return new Handlebars.SafeString(parseFloat(TSGUtils.getFileSizeAsGigabytes(docSize).toPrecision(2)) + " " + TSGUtils.FILE_SIZE_ABBREVIATIONS.GIGABYTE);
		} else if (docSize >= TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_MEGABYTE && docSize < TSGUtils.FILE_SIZE_CONVERSIONS.BYTES_TO_GIGABYTE) {
			// a doc size that is at least 1 MB but smaller than 1 GB should be displayed as a MB
			return new Handlebars.SafeString(parseFloat(TSGUtils.getFileSizeAsMegabytes(docSize).toPrecision(2)) + " " + TSGUtils.FILE_SIZE_ABBREVIATIONS.MEGABYTE);
		} else {
			// any doc sizes smaller than 1 MB should be displayed as a KB
			return new Handlebars.SafeString(parseFloat(TSGUtils.getFileSizeAsKilobytes(docSize).toPrecision(2)) + " " + TSGUtils.FILE_SIZE_ABBREVIATIONS.KILOBYTE);
		}
	});

	// General helper that lets us evaluate various javascript operators againts values
	Handlebars.registerHelper("evaluateOperator", function (val1, operator, val2, options) {
		if (operator === "!") {
			// This is for any operators that should only have one value to check (like !)
			if (val2) {
				throw new Error("Should provide no second value for the conditonal helper with operator \"!\", provided \"" + val2 + "\"")
			}
			return eval(operator + "val1") ? options.fn(this) : options.inverse(this);
		} else {
			return eval("val1" + operator + "val2") ? options.fn(this) : options.inverse(this);
		}
	});
	return Handlebars;
});
